import React from 'react';

import {defineMessage} from '../../../../../../libs/shared/core/src/helpers/internationalization/message';
import {SearchSuggestionsDropdownItem} from './searchSuggestionsDropdownItem';

export const SearchSuggestionsDropdownKeywordExclusion = () => {
  const message = defineMessage({
    id: 'search-suggestion-prefix-excluded',
    message: 'exclude keywords',
  });
  const label = `${message.message}`;
  return (
    <SearchSuggestionsDropdownItem
      label={label}
      fuzzyQuery=""
      prefix="-"
      shouldBoldPrefix
      shouldItalicizeLabel
    />
  );
};
